
export default {
  vegetationIndexAverageContext: new Map(),
  vegetationIndexAverageForCropTypeNotConfirmedContext: new Map(),
  vegetationIndexCropsContext: new Map(),
  averageStatus: new Map(),
  averageStatusForCropTypeNotConfirmed: new Map(),
  cropStatus: new Map(),
};
